import { IButtonProps as FIButtonProps, IButtonStyles, IconButton as FIconButton } from '@fluentui/react';
import { forwardRef, LegacyRef } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { iconButtonStylesDefault } from './IconButton.styles';

export interface IIconButtonProps extends Omit<FIButtonProps, 'styles'>, IComponent<Partial<IButtonStyles>> {
  iconName?: string;
}

export const IconButton = forwardRef((props: IIconButtonProps, ref: LegacyRef<FIconButton>) => {
  const { iconName, styles, ..._fProps } = props;
  const { iconProps } = props;
  const fProps = {
    ..._fProps,
    iconProps: iconProps ? iconProps : iconName ? { iconName } : undefined,
    styles: useThemeStyles<IButtonStyles>(iconButtonStylesDefault, styles),
  };
  return <FIconButton {...fProps} ref={ref} data-test={props['data-test'] || 'icon-button'} />;
});
